import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterStateService {
// Maintain filter state with pagination info inside
private filterStates: { [key: string]: { filters: any} } = {};

  constructor() { }

  // Set the filter state and pagination within the same object
  setFilterState(key: string, filter: any) {
    this.filterStates[key] = {
      filters: filter
    };
  }

  getFilterState(key: string) {
    return this.filterStates[key] || null;
  }

  clearFilterState(key: string) {
    delete this.filterStates[key];
  }

  resetAllFilterState(){
    this.filterStates = {};
  }
}
